import { apiJSON, apiFetch, jsonBody } from './http'
import { auth, expireSession, setSession, sessionToken } from './session'

export { auth } from './session'

export async function restoreSession() {
  if (!sessionToken()) { auth.ready = true; return }
  try { auth.user = await apiJSON('/api/auth/me'); auth.error = '' }
  catch (error) { auth.error = error.message }
  finally { auth.ready = true }
}

export async function login(username, password) {
  const data = await apiJSON('/api/auth/login', jsonBody('POST', { username, password }))
  setSession(data.token, data.user)
  localStorage.setItem('ai_user', JSON.stringify(data.provider_user || {}))
  auth.error = ''
}

export async function logout() {
  try { if (sessionToken()) await apiFetch('/api/auth/logout', { method: 'POST' }) }
  finally { expireSession() }
}

window.addEventListener('storage', event => {
  if (event.key === 'ai_token') {
    setSession(event.newValue || '', null)
    restoreSession()
  }
})
